import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const feedbackResource = '/merchant/feedback'

const defaultPagination = 5

export default {
  getFeedbackSetting() {
    return OperationRepository.get(`${feedbackResource}/setting`)
  },
  createFeedback(payload) {
    return Repository.post(`${feedbackResource}`, payload)
  },
  getFeedback(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${feedbackResource}?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getFeedbackNoPagination(filterQuery) {
    return Repository.get(`${feedbackResource}?${filterQuery}&noPagination`)
  },
}
